var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2964L10.7163 6.14818L0 -3.14713e-05L1.33171 6.14818L0 12.2964Z",
    fill: "#F9D35E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.734076 11.454L9.98209 6.14821L0.734076 0.84237L1.88367 6.14821L0.734076 11.454Z",
    fill: "#FFC93C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c1981e1668296a6e1c0dd021dc5c471b.svg";
export { ForwardRef as ReactComponent };